module.exports = __webpack_public_path__ + "static/media/website.c725d5cb.png";